<template>
  <v-container fluid>
    <ComponenteLoading :is-loading="loading" :message="mensaje_loading" />
    <v-card class="pa-4">
      <v-row class="pa-4">
        <div class="text-h6 mb-2" :disabled="disabled">
          {{ $t('simulacion.modulo.datos_economicos.reparto_CAPEX') }}
        </div>
      </v-row>

      
      <!-- TABLA REPARTO CAPEX x3 -->
      <v-row class="pa-4">
        <v-table :disabled="disabled" class="elevation-2 custom-table">
          <thead class="table-header">
            <tr>
              <th class="table-header-cell">{{ $t('simulacion.modulo.datos_economicos.anio') }}</th>
              <th class="table-header-cell">{{ $t('simulacion.modulo.datos_economicos.reparto_capex_h2') }}</th>
              <th v-if="ejecucion.OPC_PV !== 0" class="table-header-cell">{{ $t('simulacion.modulo.datos_economicos.reparto_capex_fv') }}</th>
              <th v-if="ejecucion.OPC_EOL !== 0" class="table-header-cell">{{ $t('simulacion.modulo.datos_economicos.reparto_capex_eol') }}</th>
            </tr>
          </thead>
          <tbody class="table-body">
            <tr v-for="(fila, idx) in filasReparto" :key="idx" class="table-row">
              <td class="table-cell">
                <v-text-field
                  :model-value="fila.ano"
                  readonly hide-details density="compact" variant="plain"
                  class="negrita capex-input"
                />
              </td>

              <!-- H2 -->
              <td class="table-cell">
                <v-text-field
                  :disabled="disabled"
                  :model-value="formatNumber(fila.h2)"
                  @blur="e => EditarPorcentaje(idx, e.target.value, 'capexh2')"
                  @keyup.enter="e => EditarPorcentaje(idx, e.target.value, 'capexh2')"
                  @change="validarSumaLocal"
                  min="0" max="100" hide-details density="compact" variant="plain" class="capex-input"
                />
              </td>

              <!-- FV -->
              <td class="table-cell" v-if="ejecucion.OPC_PV !== 0">
                <v-text-field
                  :disabled="disabled || fila.ano>datos_generales.anio_inicio_solar"
                  v-if="fila.ano<=datos_generales.anio_inicio_solar"
                  :model-value="formatNumber(fila.pv)"
                  @blur="e => EditarPorcentaje(idx, e.target.value, 'capexpv')"
                  @keyup.enter="e => EditarPorcentaje(idx, e.target.value, 'capexpv')"
                  @change="validarSumaLocal"
                  min="0" max="100" hide-details density="compact" variant="plain" class="capex-input"
                />
                <span v-if="fila.ano > datos_generales.anio_inicio_solar" 
                  class="capex-placeholder mt-n0"
                    >
                    -
                </span>
              </td>

              <!-- Eólica -->
              <td class="table-cell" v-if="ejecucion.OPC_EOL !== 0">
                <v-text-field
                  :disabled="disabled || fila.ano>datos_generales.anio_inicio_eolica"
                  v-if="fila.ano<=datos_generales.anio_inicio_eolica"
                  :model-value="formatNumber(fila.eol)"
                  @blur="e => EditarPorcentaje(idx, e.target.value, 'capexeol')"
                  @keyup.enter="e => EditarPorcentaje(idx, e.target.value, 'capexeol')"
                  @change="validarSumaLocal"
                  min="0" max="100" hide-details density="compact" variant="plain" class="capex-input"
                />

                <span v-if="fila.ano > datos_generales.anio_inicio_eolica" 
                      class="capex-placeholder mt-n0">
                    -
                </span>
              </td>
            </tr>
          </tbody>
        </v-table>

        <!-- Errores de suma por columna -->
        <v-col cols="12" class="d-flex flex-column gap-2 mt-4">
          <v-alert v-if="errorSuma.h2" type="error" dense outlined class="error-alert">
            La suma de % CAPEX H2 debe ser 100%.
          </v-alert>
          <v-alert v-if="errorSuma.pv" type="error" dense outlined class="error-alert">
            La suma de % CAPEX FV debe ser 100%.
          </v-alert>
          <v-alert v-if="errorSuma.eol" type="error" dense outlined class="error-alert">
            La suma de % CAPEX eólica debe ser 100%.
          </v-alert>
        </v-col>
      </v-row>

      <v-row class="pa-4">
        <div class="text-h6 mb-2" :disabled="disabled">
          {{ $t('simulacion.modulo.datos_economicos.titulo_tabla') }}
        </div>
        <v-col cols="12" class="d-flex justify-end mb-2">
          <v-btn color="primary" class="mx-2" @click="exportToCSV">
            {{ $t('comun.boton_exportar') }}
          </v-btn>

          <v-btn :disabled="disabled" color="primary" class="mx-2" @click="importFromCSV">
            {{ $t('comun.boton_importar') }}
            <input
              type="file"
              accept=".csv"
              ref="fileInputSubv"
              style="display: none;"
              @change="handleCSVUpload"
            />
          </v-btn>
        </v-col>
      </v-row>

      <v-row class="pa-4">
        <v-table :disabled="disabled" class="elevation-2 custom-table">
          <thead class="table-header">
            <tr>
              <th class="table-header-cell">{{ $t('simulacion.modulo.datos_economicos.anio_inicio') }}</th>
              <th class="table-header-cell">{{ $t('simulacion.modulo.datos_economicos.columna_subvencion') }}</th>
              <th class="table-header-cell">{{ $t('simulacion.modulo.datos_economicos.columna_subv_RFNBO') }}</th>
            </tr>
          </thead>
          <tbody class="table-body">
            <tr v-for="(anio, i) in listaAniosCapex" :key="i" class="table-row">
              <td class="table-cell">
                <v-text-field
                  :model-value="anio" readonly hide-details density="compact" variant="plain"
                  class="negrita capex-input"
                />
              </td>
              <td class="table-cell">
                <v-text-field
                  :disabled="disabled"
                  v-model.number="localSubvCapex[i]"
                  type="number" min="0" step="1"
                  hide-details density="compact" variant="plain" class="capex-input"
                  @change="emitirSubv()"
                />
              </td>
              <!--  subvh2v -->
              <td class="table-cell">
                <v-text-field
                  :disabled="disabled || anio<datos_generales.anio_inicio"
                  v-model.number="localSubvH2v[i]"
                  type="number" min="0" step="0.001"
                  hide-details density="compact" variant="plain" class="capex-input"
                  @change="emitirSubv()"
                />
              </td>
            </tr>
          </tbody>
        </v-table>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import ComponenteLoading from './ComponenteLoading.vue';
import Swal from "sweetalert2";

export default {
  name: 'ComponenteDatosEconomicos',
  components: { ComponenteLoading },
  props: {
    datos_generales: { type: Object, required: true },   // anio_inicio, anio_fin
    datos_economicos: { type: Object, required: true },  // anio_inicio_capex, reparto_capex (p.u.), subvcapex
    disabled: { type: Boolean, default: false },
    ejecucion:{type: Object, required:true},
    id_simulacion: { type: [String, Number], default: null },
  },
  data() {
    return {
      loading: false,
      mensaje_loading: '',
      errorSuma: { h2:false, pv:false, eol:false },
      localSubvCapex: [],
      localSubvH2v: [],
    };
  },
  computed: {
    // Filas para la tabla de reparto: convertimos p.u. -> %
    filasReparto() {
      const rep = this.datos_economicos.reparto_capex ?? [];
      return rep.map(r => ({
        ano: r.ano,
        h2:  Number(r.capexh2  ?? r.valor ?? 0) * 100,
        pv:  Number(r.capexpv  ?? r.valor ?? 0) * 100,
        eol: Number(r.capexeol ?? r.valor ?? 0) * 100,
      }));
    },
    listaAniosCapex() {
      const ini = +this.datos_economicos.anio_inicio_capex;
      const fin = +this.datos_generales.anio_fin;
      if (!ini || !fin || ini > fin) return [];
      return Array.from({ length: fin - ini + 1 }, (_, i) => ini + i);
    },
  
  },
  watch: {
    
    'datos_economicos.subvcapex': {
      immediate: true,
      deep: true,
      handler(val) {
        this.localSubvCapex = Array.isArray(val) ? [...val] : [];
      }
    },
    'datos_economicos.subvh2v': {
    immediate: true,
    deep: true,
    handler(val) {
      this.localSubvH2v = Array.isArray(val) ? [...val] : [];
    }
  },
     'datos_economicos.reparto_capex': {
    deep: true,
    immediate: true,
    handler() { this.validarSumaLocal(); }
  },
  },
  methods: {
  formatNumber(v){ if(v===null||v===undefined||v==='')return ''; const n=Number(v); if(Number.isNaN(n))return ''; const r=Math.round(n*100)/100; return (r%1===0)?String(r):String(r.toFixed(2)).replace('.',','); },
    parsePorcentaje(v){ if(v===null||v===undefined||v==='')return 0; const n=Number(String(v).replace(',','.')); const b=Number.isFinite(n)?n:0; return Math.max(0,Math.min(100,Math.round(b*100)/100)); },

    // MISMO MÉTODO pero con "clave"
    EditarPorcentaje(index, nuevoValor, clave) {
      const percent = this.parsePorcentaje(nuevoValor);
      const pu = percent / 100;
      const rep = (this.datos_economicos.reparto_capex ?? []).map((r,i)=>{
        const row = ('capexh2' in r || 'capexpv' in r || 'capexeol' in r)
          ? { ...r }
          : { ano:r.ano, capexh2:r.valor||0, capexpv:r.valor||0, capexeol:r.valor||0 };
        return i===index ? { ...row, [clave]: pu } : row;
      });

      this.$emit('update:datos_economicos', { ...this.datos_economicos, reparto_capex: rep });
      this.$emit('capex-edit-manual');
      this.validarSumaLocal();
    },

  validarSumaLocal() {
  // Asegura estructura (legacy {valor} -> 3 columnas)
  const rep = (this.datos_economicos.reparto_capex ?? []).map(r =>
    ('capexh2' in r)
      ? r
      : { ano: r.ano, capexh2: r.valor || 0, capexpv: r.valor || 0, capexeol: r.valor || 0 }
  );

  const sum = k => rep.reduce((a, r) => a + (Number(r[k]) || 0), 0);
  const tol = 0.005; // 0.5% en p.u.

  const sH2  = sum('capexh2');
  const sPV  = sum('capexpv');
  const sEOL = sum('capexeol');

  // mantener errorSuma como OBJETO
  this.errorSuma = {
    h2:  Math.abs(sH2  - 1) > tol,
    pv: this.ejecucion.OPC_PV !== 0? Math.abs(sPV  - 1) > tol:false,
    eol: this.ejecucion.OPC_EOL !== 0? Math.abs(sEOL - 1) > tol:false
  };
},

    emitirSubv() {
  const nuevosDatosEconomicos = {
    ...this.datos_economicos,
    subvcapex: [...this.localSubvCapex],
    subvh2v: [...this.localSubvH2v],
  };

  this.$emit('update:datos_economicos', nuevosDatosEconomicos);
  this.$emit('subv-edit-manual', nuevosDatosEconomicos);
},
    exportToCSV() {
  const years = this.listaAniosCapex || [];
  if (!years.length) return;

  // Cabecera técnica estable
  const headers = ["anio", "subvcapex", "subvh2v"].join(";");

  const rows = years.map((anio, i) => {
    const a = anio;
    const v1 = Number(this.localSubvCapex?.[i] ?? 0);
    const v2 = Number(this.localSubvH2v?.[i] ?? 0);

    // export en formato ES (coma) para consistencia con el resto
    const s1 = Number.isFinite(v1) ? String(v1).replace(".", ",") : "0";
    const s2 = Number.isFinite(v2) ? String(v2).replace(".", ",") : "0";

    return [a, s1, s2].join(";");
  });

  const csvContent = [headers, ...rows].join("\n");
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "subvenciones.csv";
  a.click();
  URL.revokeObjectURL(url);
},

importFromCSV() {
  this.$refs.fileInputSubv?.click();
},

handleCSVUpload(event) {
  const file = event.target.files?.[0];
  if (!file) return;

  const reader = new FileReader();
  reader.onload = (e) => {
    const csvData = e.target.result;

    const [headerLine, ...lines] = csvData
      .split("\n")
      .map((line) => line.trim())
      .filter((line) => line.length > 0);

    if (!headerLine) return;

    const MAX_ROWS = (this.listaAniosCapex || []).length || 0;
    if (MAX_ROWS && lines.length > MAX_ROWS) {
      Swal.fire({
        icon: "error",
        title: this.$t("mensajes.excel_demasiadas_filas_titulo") || "Demasiadas filas",
        html:
          (this.$t("mensajes.excel_demasiadas_filas_texto") || "El fichero supera el máximo permitido.") +
          `<br><b>${lines.length.toLocaleString()}</b> filas detectadas. Máximo permitido: <b>${MAX_ROWS.toLocaleString()}</b>.`,
        confirmButtonText: "OK",
      });
      event.target.value = "";
      return;
    }

    const headers = headerLine.split(";");
    if (!headers.includes("anio")) {
      Swal.fire({
        icon: "error",
        title: "CSV inválido",
        text: "Falta la columna 'anio' en la cabecera.",
      });
      event.target.value = "";
      return;
    }

    // Parseo a mapa por año
    const idxAnio = headers.indexOf("anio");
    const idxCapex = headers.indexOf("subvcapex"); // puede no existir
    const idxH2v = headers.indexOf("subvh2v");     // puede no existir

    const byYear = new Map();

    lines.forEach((line) => {
      const values = line.split(";");
      const yRaw = values[idxAnio] ?? "";
      const y = parseInt(String(yRaw).replace(",", "."), 10);
      if (!Number.isFinite(y)) return;

      const parseNum = (raw) => {
        const n = Number(String(raw ?? "").replace(",", "."));
        return Number.isFinite(n) ? n : 0;
      };

      const capex = idxCapex >= 0 ? parseNum(values[idxCapex]) : undefined;
      let h2v   = idxH2v >= 0 ? parseNum(values[idxH2v]) : undefined;
      // Forzar a 0 si es el año menor que el COD
      if (y<this.datos_generales.anio_inicio){
        h2v=0;
      }
      byYear.set(y, { capex, h2v });
    });

    // Aplicar sobre los años esperados del grid
    const years = this.listaAniosCapex || [];

    const nextCapex = [...(this.localSubvCapex || [])];
    const nextH2v   = [...(this.localSubvH2v || [])];

    years.forEach((y, i) => {
      const found = byYear.get(y);
      if (!found) return;

      if (found.capex !== undefined) nextCapex[i] = found.capex;
      if (found.h2v   !== undefined) nextH2v[i]   = found.h2v;
    });

    this.localSubvCapex = nextCapex;
    this.localSubvH2v = nextH2v;

    this.emitirSubv();
  };

  reader.readAsText(file, "UTF-8");
  event.target.value = "";
},
  },
};
</script>

<style scoped>
.capex-placeholder {
    /* Estilos para centrar el guion y que ocupe espacio similar al input */
    display: block;
    text-align: left; 
    width: 100%;
    top: -4px;
    padding-left: 8px;
}
.custom-table {
  border-radius: 10px;
  overflow: hidden;
  
}

.table-header {
  background-color: #0078D4;
  color: white;
}

.table-header-cell {
  min-width: 110px;
  font-size: 16px;
  padding: 12px;
  border-right: 1px solid #ffffff;
  text-align: center !important;
 
}

.table-body {
  background-color: #ebeaea;
  min-width: 130px;
}


.table-cell {
  min-width: 110px;
  font-size: 16px;
  padding: 12px;
  border-right: 1px solid #ffffff;
  text-align: center !important;
  justify-content: center;
}

.negrita {
  font-weight: bold;
  align-items: center;

}

.error-alert {
  max-width: 300px;
  margin-top: 16px;
}
.capex-input {
  background-color: transparent !important;
  font-size: 16px;
  text-align: center;
  padding: 0 !important;
  margin: 0 !important;
  height: 36px;
  width: 100%;
  justify-content: center;
}

.capex-input input {
  text-align: center !important;
  padding: 0 !important;
  margin: 0 !important;
  height: 100%;
  font-weight: bold;
  font-size: 16px;
}




</style>
